import styled from 'styled-components'
import Flex from 'components/Flex'
import Drawer from 'components/Drawer'
import { Form,Radio as AntdRadio, Form as AntdForm,Radio } from 'antd'
import Control from 'components/Control/Control'
import AntdInput from 'components/Form/Input'
import SelectLocal from 'components/Select/Select'
export const FormItem = styled(AntdForm.Item)`
  margin-bottom: ${props =>
    props.marginbottom ? props.marginbottom : '0px'} !important;
  width: 100%;
  .ant-form-item-explain-error {
    padding-left: ${props => (props.padding ? '15%' : '0')};
  }
`
export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    &::-webkit-scrollbar {
      display: '';
    }
  }
  .ant-drawer-title {
    font-weight: 700;
  }
`
export const FooterFlex = styled(Flex)`
  gap: 20px;
`
export const FormWrapper = styled(Form)`
  width: 100%;
`
export const ImageUploadWrapper = styled(Flex)`

  background: #f9fafe;
  border: ${props => props?.boarder && '1px dashed #98a4eb'};
  border-radius: 20px;
  height: 110px;
  width: 110px;
  margin:auto;
  margin-top: 35px;
  ${ImageUploadWrapper} > ${Control} > div {
    font-weight: 500;
    font-size: 8px;
    line-height: 8px;
    color: #cccfd6;
  }
`
export const ImageTag = styled.img`
  border-radius: 20px;
  height: 140px;
  width: 120px;
`

export const UploadText = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #3249d7;
  cursor: pointer;
 
`
export const FileInput = styled.input`
  opacity: 0;
  display: block;
  width: 100px;
  position: relative;
  top: -30px;
`
export const AddIcon = styled.div`
  margin-top: 5px;
  margin-right: 5px;
  cursor: pointer;
`
export const Heading = styled.div`
  font-weight: 600;
  font-size: 1.1428571428571428em;
  line-height: 21px;
  color: #1b1f22;
`
export const StyledSelectDiv = styled(Flex)`
  height: 48px;
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-right: 0;
  }
`
export const StyledInput = styled(AntdInput)`
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
`
export const StyledInputDiv = styled(Flex)`
  margin-bottom: 20px !important;
  align-items: baseline;
  width: 100%;
  border-radius: 8px;
  .ant-inputselect:not(.ant-select-customize-input) .ant-select-selector {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }
  `

  export const ButtonLocal = styled.button`
  width: 100%;
  background: #ffffff;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  padding: 10px;
`

export const Text = styled.div`
  font-weight: 600;
  font-size: 1em;
  line-height: 18px;
  color: #3249d7;
`

export const SelectLocalWrapper = styled(SelectLocal)`
  position: relative;
  top: -60px;
  opacity: 0 !important;
  width: 50%;
  background: #ffffff;
  border: 1px solid #ebecee;
  box-shadow: 0px 4px 12px rgba(153, 153, 153, 0.1);
  border-radius: 10px;
  pointer-events: auto;
  
  .ant-select-arrow {
    display: none !important;
  }
  
  .ant-select-selector {
    opacity: 0 !important;
  }
`
export const AdjustIcon = styled.div`
  margin-top: 6px;
`

export const OptionWrapper = styled(Flex)`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${props => (props?.isAdded ? '#B3B7C1' : '#343e59')};
  height: 35px;
  padding-left: 15px;
  pointer-events: ${props => (props?.isAdded ? 'none' : 'auto')};
`

export const SubHeading = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: #999fac;
  margin-top: 5px;
`
export const RadioGroup = styled(Radio.Group)`
  display: flex;
  width: 85%;
`

export const RadioGroupNew = styled(AntdRadio.Group)`
  display: flex;
  gap: ${props => (props.gap ? props.gap : '15px')};
  margin-top: 8px;
  ${props => props?.spaceBetween && 'justify-content: space-between;'}
`

export const LocalDiv = styled(Flex)`
  width: 100%;
  background: #ffffff;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  padding: 10px;
  margin-top: 2px;
  cursor: pointer;
`
export const DrawerListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;   /* spacing only inside drawer */
  margin-top: 10px;
`;
